import React from "react";
import xMarkIcon from "../assets/icons/xmark.svg";
import "../styles/layoutStyles.css";

interface BannerNotificationProps {
  message: string;
  onClose: () => void;
  onStartSession: () => void;
}

const BannerNotification: React.FC<BannerNotificationProps> = ({
  message,
  onClose,
  onStartSession,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "var(--color-brand-green)",
        color: "black",
        padding: "10px",
        textAlign: "center",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div>
        <span>{message}</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onStartSession();
          }}
        >
          Start session?
        </a>
      </div>
      <button className="small-icon-button" onClick={onClose}>
        <img
          src={xMarkIcon}
          className="small-icon-button"
          alt="close"
          style={{ filter: "brightness(0)" }}
        />
      </button>
    </div>
  );
};

export default BannerNotification;
